import { useRef, useState } from "react";

import { useContentfulInspectorMode } from "@contentful/live-preview/react";

import { Button } from "~/components/ui/button";
import { MediaPlayIcon } from "~/components/ui/icons/media-play-icon";
import type { TypeVideo } from "~/contentful/compiled";
import { ContentfulImage } from "~/contentful/components/contentful-image";
import type { SerializeFrom } from "~/lib/types";

const PDPVideo = ({
  content,
}: {
  content: SerializeFrom<TypeVideo<"WITHOUT_UNRESOLVABLE_LINKS", string>>;
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [playVideo, setPlayVideo] = useState<boolean>(false);
  const [showPlayButton, setShowPlayButton] = useState<boolean>(true);
  const inspectorProps = useContentfulInspectorMode();

  const onPlayVideo = () => {
    videoRef?.current?.play();
    setPlayVideo(true);
    setTimeout(() => {
      setShowPlayButton(false);
    }, 3000);
  };

  const onPauseVideo = () => {
    videoRef?.current?.pause();
    setPlayVideo(false);
    setShowPlayButton(true);
  };

  return (
    <div className="relative h-[363px] px-[40px] py-[24px] sm:h-[277px] lg:h-[449px] 2xl:h-[672px]">
      {!videoRef.current && !playVideo ? (
        <span
          {...inspectorProps({
            entryId: content.sys.id,
            fieldId: "name",
          })}
        >
          <ContentfulImage
            key={content.fields.name}
            className="h-full w-full rounded-lg object-cover"
            alt={content.fields.thumbnail?.fields.title ?? ""}
            imageUrl={content.fields.thumbnail?.fields.file?.url || ""}
            //maxWidth="full"
          />
        </span>
      ) : (
        <video
          ref={videoRef}
          key={content.fields.name}
          src={content.fields.video?.fields.file?.url}
          autoPlay={playVideo}
          loop={playVideo}
          onClick={() => (playVideo ? onPauseVideo() : onPlayVideo())}
          muted
          playsInline
          className="h-full w-full cursor-pointer rounded-lg object-cover"
          {...inspectorProps({
            entryId: content.sys.id,
            fieldId: "name",
          })}
        />
      )}
      {(videoRef.current?.paused || showPlayButton) && (
        <Button
          as="a"
          aria-label="play-video"
          variant="linkInline"
          className="absolute bottom-[45%] left-[42%] z-10 cursor-pointer lg:left-[47%]"
          onClick={() => (playVideo ? onPauseVideo() : onPlayVideo())}
        >
          <MediaPlayIcon />
        </Button>
      )}
    </div>
  );
};

export default PDPVideo;
